import ACTIONS from "../constants/actions";

const {
  CHECK_ORGANIZATION_REQUEST,
  CHECK_ORGANIZATION_REQUEST_FAIL,
  CHECK_ORGANIZATION_REQUEST_SUCCESS,
} = ACTIONS;

const initialState = {
  isLoading: false,
  orgExist: true,
};

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHECK_ORGANIZATION_REQUEST:
      return {
        isLoading: true,
        ...state,
      };
    case CHECK_ORGANIZATION_REQUEST_SUCCESS:
      return {
        isLoading: false,
        orgExist: action.payload,
      };
    case CHECK_ORGANIZATION_REQUEST_FAIL:
      return {
        isLoading: false,
        orgExist: false,
      };
    default:
      return state;
  }
};

export default appReducer;
